var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrencyIconBitcoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "currency-icon_bitcoin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003FD1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5047681,5.86667 L25.5047681,11.029617 C30.287625,11.1401869 33.1437181,13.5401773 33.1437181,17.4230328 C33.1437181,20.1487455 31.1313346,22.52157 28.493049,22.9124286 L28.493049,23.2338586 C31.8976188,23.4832857 34.374187,26.0515418 34.374187,29.3661145 C34.374187,33.8661129 30.9793363,36.7110785 25.5047681,36.7187928 L25.5047681,41.86667 L20.3619097,41.86667 L20.3619097,36.7238116 L13.93334,36.7238116 L13.93334,11.0095284 L20.3619097,11.0095284 L20.3619097,5.86667 L25.5047681,5.86667 Z M23.9829997,25.3030498 L19.3172654,25.3030498 L19.3172654,32.6055089 L24.1085587,32.6055089 C27.2097014,32.6055089 28.8847867,31.3033196 28.8847867,28.8990325 C28.8847867,26.5461755 27.153571,25.3030498 23.9829997,25.3030498 Z M23.8072216,15.1278266 L19.3172654,15.1278266 L19.3172654,21.6668899 L23.3602371,21.6668899 C26.2659528,21.6668899 27.8501889,20.474831 27.8501889,18.4074025 C27.8501889,16.3579726 26.3735088,15.1278266 23.8072216,15.1278266 Z",
    id: "Combined-Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyIconBitcoin);
export default __webpack_public_path__ + "static/media/currency-icon_bitcoin.2b9ca90eb6ef6c788c5753176da27f1a.svg";
export { ForwardRef as ReactComponent };